export const LEGALBOT_LAWFIRM = {
  id: 0,
  name: 'LegalBot',
  email: 'contacto@legalbot.cl',
  isActive: true,
  lawFirm: 1,
};
